import React, { useContext, useEffect } from "react";
import "../css/paysuccess.css";
import Header from "./Header";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useSearchParams } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const { clearCart } = useContext(CartContext);
  const isSuccess = searchParams.get("state") === "success";

  useEffect(() => {
    if (isSuccess) clearCart();
  }, [isSuccess, clearCart]);

  return (
    <>
      <Header />
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`payment-state-icon ${isSuccess ? "success" : "cancel"}`}>
              <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
            </div>
            <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
            <p>
              {isSuccess
                ? "Thank you. Your order has been received and is being processed."
                : "Your payment was not completed. Your cart has been saved."}
            </p>
            <Link className="payment-state-link" to={isSuccess ? "/shop" : "/checkout"}>
              {isSuccess ? "Continue shopping" : "Return to checkout"}
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PaySuccess;
